var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import * as constants from '@adc/constants';
import configment from '@adc/configment';
import wellKnownSymbols from './wellKnownSymbols';
const HTTP_FETCH_FAILURE_CODE = 0;
const ADC_FETCH_USER_AGENT = 'adc/fetch';
export const defaultStaticFetchOptions = {
    fetchOptionsCheck: (_url, options) => options,
};
export const serializeParams = (params) => Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
export const constructUrl = (url, params = {}) => {
    if (_.isEmpty(params)) {
        return url;
    }
    if (_.isPlainObject(params))
        params = serializeParams(params);
    return `${url}?${params}`;
};
export const userAgent = () => [ADC_FETCH_USER_AGENT, configment.get('APP_NAME', '').replace(/-/g, '_')]
    .filter(Boolean)
    .join('/');
export const attemptAutomaticBodySerialization = (options) => {
    if (options.body &&
        typeof options.body === 'object' &&
        options.headers['Content-Type'] === 'application/json') {
        options.body = JSON.stringify(options.body);
        options.headers['Content-Type'] = 'application/json';
    }
};
export const stripNonStandardFetchOptions = (options) => {
    delete options.useProxy;
    delete options.req;
    stripUnwantedHeaders(options.headers);
};
const stripUnwantedHeaders = (headers) => {
    for (const [key, value] of Object.entries(headers)) {
        if (value === wellKnownSymbols.removeHeader) {
            delete headers[key];
        }
    }
};
export const executeRequest = (url, options, executeOptions) => {
    const { timeoutID, fetchOptionsCheck } = executeOptions;
    executeOptions.eventCapture.on('request:start', {
        uri: url,
        body: options.body,
        headers: options.headers,
        xcid: options.headers['x-cid'] || null,
        userId: null,
        httpMethod: options.method,
    });
    let timesTried = 0;
    function doRequest() {
        const plainFetch = () => __awaiter(this, void 0, void 0, function* () {
            const checkedOptions = yield fetchOptionsCheck(url, options);
            return yield fetch(url, checkedOptions);
        });
        timesTried++;
        return plainFetch()
            .catch((err) => {
            if (timesTried < executeOptions.tries) {
                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        plainFetch().then(resolve).catch(reject);
                    }, executeOptions.retryTimeout);
                });
            }
            throw err;
        })
            .then(response => {
            if (timeoutID) {
                ;
                response.timeoutID = timeoutID;
            }
            if (response.ok) {
                return executeOptions.parseResponse(response);
            }
            return executeOptions
                .parseResponse(response)
                .then((response) => {
                if (response.body && typeof response.body === 'object') {
                    ;
                    response.body.url = url;
                    response.body.method =
                        options.method || 'GET';
                }
                throw response;
            });
        })
            .then((parsedResponse) => {
            executeOptions.eventCapture.on('response:success', {
                statusCode: parsedResponse.status || constants.httpStatusCodes.OK,
                body: parsedResponse.body || {},
                headers: parsedResponse.headers,
            });
            return parsedResponse;
        })
            .catch((err) => {
            executeOptions.eventCapture.on('response:failure', {
                statusCode: err.status || HTTP_FETCH_FAILURE_CODE,
                body: err.body || {},
                headers: err.headers,
            });
            throw err;
        });
    }
    return doRequest();
};
export const attachMethodHandlers = (fetchImplementation) => ['get', 'post', 'put', 'patch', 'delete'].forEach(method => {
    ;
    fetchImplementation[method] = (url, opts) => fetchImplementation(url, Object.assign(Object.assign({}, opts), { method: method.toUpperCase() }));
});
export const methodFactory = (fetchImplementation, method) => (url, opts) => fetchImplementation(url, Object.assign(Object.assign({}, opts), { method: method }));
const createBoundedFetch = (instance) => {
    instance.__internal = instance.__internal || Object.create(null);
    const boundFetch = instance.bind(instance);
    boundFetch.__internal = instance.__internal;
    attachMethodHandlers(boundFetch);
    return boundFetch;
};
export const boundedFetchFactory = (fetchImplementation) => (serviceKey) => {
    const boundFetch = createBoundedFetch(fetchImplementation);
    boundFetch.__internal.host = configment.get(serviceKey);
    return boundFetch;
};
//# sourceMappingURL=common.js.map